import { z } from 'zod/v4';
export const WebSearchInputSchema = z.object({
    question: z.string(),
});
export const WebSearchResultSchema = z.object({
    answer: z.string(),
    sources: z.array(z.object({
        name: z.string(),
        url: z.string(),
    })),
});
//# sourceMappingURL=fda-search.js.map